<template>
  <div class="w-100 overflow-y-auto">
    <div class="container">
      <h2 class="text-center mb-4">
        {{ $t("editarParceiro") }}
      </h2>
      <ParceiroForm
        v-if="!!parceiro.nome" class="mb-4" v-bind="parceiro" :loading="loading"
        @salvar-parceiro="onSave"
      />
    </div>
  </div>
</template>
<script>
import ParceiroForm from './components/ParceiroForm';
import { updateParceiro, getParceiro } from './parceiroService';
import { useToast } from 'vue-toastification';

export default {
  components: { ParceiroForm },
  props: {
    id: { type: String, required: true },
  },
  data: () => ({ parceiro: {}, loading: false }),
  async created() {
    this.loading = true;
    try {
      const response = await getParceiro(this.id);
      if (response) {
        this.parceiro = response;
      } else {
        useToast().error('Parceiro não encontrado.');
      }
    } catch (error) {
      useToast().error('Erro de conexão.');
    }
    this.loading = false;
  },
  methods: {
    async onSave(parceiro) {
      this.loading = true;
      try {
        const response = await updateParceiro(this.id, parceiro);
        if (response) {
          useToast().success('Parceiro alterado com sucesso.');
        } else {
          useToast().error(response);
        }
      } catch (error) {
        useToast().error('Erro de conexão');
      }
    },
  },
};
</script>
